export default __webpack_public_path__ + "static/media/github.895050b2.svg";